<template>
    <div class="entity-concept-list-card w-100">
        <AonContainer>
            <AonRow class="mt-sm">
                <AonCol class="grid-cols-12 p-0 flex-column justify-center">
                    <AonCard
                        title="Concept List"
                        :desc="`Flat list of Concepts for ${entityStore?.entity?.name}`"
                    >
                        <div class="card-content">
                            <AonCoverLoading
                                :loading="loading"
                                title="Gathering Company Concepts..."
                            ></AonCoverLoading>
                            <AonRow class="mt-xl h-100 align-items-start">
                                <AonCol class="grid-cols-12 p-0 flex-column justify-center h-100">
                                    <EntityConceptFlatListTable
                                        v-if="conceptListData?.length > 0 && !loading"
                                        :tableData="conceptListData"
                                    />
                                </AonCol>
                            </AonRow>
                        </div>
                    </AonCard>
                </AonCol>
            </AonRow>
        </AonContainer>
    </div>
</template>

<script setup>
import { useEntityStore } from '@/stores'
import EntityConceptFlatListTable from '@/components/company/tabs/bottomUpProducts/EntityConceptFlatListTable.vue'
import { computed, ref, watch } from 'vue'
import { getConceptList } from '@/api/entities.js'

const entityStore = useEntityStore()

const props = defineProps({
    globalLoading: {
        type: Boolean,
        default: false,
    },
})

const loadingData = ref(true)
const conceptListData = ref(null)

const loading = computed(() => {
    return props.globalLoading || loadingData.value
})

watch(
    () => props.globalLoading,
    (val) => {
        if (val === false) {
            loadData()
        }
    }
)

const loadData = async () => {
    if (!entityStore.entity?.aon_entity_pk) {
        logger.error('No entityPk found to load concepts for.')
    }

    try {
        const { data } = await getConceptList(entityStore.entity.aon_entity_pk, {
            page_size: 50000,
        })

        conceptListData.value = data?.results
        loadingData.value = false
    } catch (error) {
        logger.error(error)
    }
}
</script>

<style lang="scss" scoped>
.entity-concept-list-card {
    position: relative;

    .card-content {
        height: 500px;
    }
}
</style>
